module.exports = __webpack_public_path__ + "img/logo-ebay-unbranded.0d0418ba.png";